import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { NotificationInterface } from '@core/store/models/notifications.interface';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';

import { NotificationsService } from '@core/services/notifications/notifications.service';


@Component({
    selector: 'core-notifications-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class CoreNotificationsMainComponent implements OnInit, OnDestroy {
    
    public readonly TYPES = NotificationsContextEnum;

    /** EVENT_VERSION_STATUS_UPDATED_SUCCESS = 'event.versions.status.updated.success',
        EVENT_VERSION_STATUS_UPDATED_FAILED = 'event.versions.status.updated.failed',
        EVENT_VERSION_APPROVAL_SENT_SUCCESS = 'event.versions.approvals.updated.success',
        EVENT_VERSION_APPROVAL_SENT_FAILED = 'event.versions.approvals.updated.failed',
        
        ACTION_RECORD_START = 'action.record.start',
        ACTION_RECORD_STOP = 'action.record.stop',
        ACTION_RECORD_PAUSE = 'action.record.pause',
        ACTION_RECORD_RESUME = 'action.record.resume', // for continue after pause 
        */

    public notifications: NotificationInterface[] = null;

    protected notificationsSubscriber: Subscription; 

    constructor(private notsSrv: NotificationsService, private cdr: ChangeDetectorRef) {
    }

    ngOnInit(){
        this.notificationsSubscriber = this.notsSrv.getNotifications().subscribe((nots: NotificationInterface[]) => {
            this.notifications = nots;
            console.log(" notification main",this.notifications);
            // Call detectChanges to trigger change detection when new notifications arrive
            // maybe markForCheck() could do the trick in the parent: it should check for any updates in the component and its child components
            this.cdr.detectChanges();
        });
        
    }

    ngOnDestroy(): void {
        this.notificationsSubscriber.unsubscribe();
    }

    // TODO: remove after dev purposes
    addSuccess(){
        
        this.notsSrv.addNotification(this.TYPES.EVENT_VERSION_STATUS_UPDATED_SUCCESS ,{id: Math.round(1000 + Math.random() * 4000)})

    }

    addFailed(){
        
        this.notsSrv.addNotification(this.TYPES.EVENT_VERSION_STATUS_UPDATED_FAILED,{id: Math.round(1000 + Math.random() * 4000)})

    }

    addAction(){
        this.notsSrv.addNotification(this.TYPES.ACTION_RECORD_START,{id: Math.round(1000 + Math.random() * 4000)})

    }


}
